export default __webpack_public_path__ + "static/media/ashuCup2.420588cc.png";